/**
 * Cuenta atrás real hasta la fecha en que sube el precio de lanzamiento (fin de verano
 * 2026-09-22). "Real" es la palabra clave: esto NO se reinicia solo ni miente. El día que
 * llegue a cero, Fran tiene que subir el precio de verdad en Shopify Admin — si no, esto se
 * convierte en el tipo de "patrón oscuro" (falsa urgencia) que persigue la normativa de
 * consumo de la UE. Ver nota en PENDIENTE-RELLENAR.md.
 *
 * Busca cualquier elemento con [data-cuenta-atras] y data-fecha="AAAA-MM-DD", y le mete dentro
 * un texto tipo "Quedan 59 días". Si la fecha ya pasó, no toca nada (así no queda un contador
 * en negativo si un día se te olvida actualizar el precio).
 */
function actualizarCuentasAtras() {
  const ahora = new Date();

  for (const nodo of document.querySelectorAll('[data-cuenta-atras]')) {
    const fecha = nodo.dataset.fecha;
    if (!fecha) continue;

    const objetivo = new Date(`${fecha}T23:59:59`);
    const msRestante = objetivo - ahora;
    if (msRestante <= 0) {
      nodo.textContent = '';
      continue;
    }

    const dias = Math.ceil(msRestante / (1000 * 60 * 60 * 24));

    if (dias === 1) {
      nodo.textContent = 'Sube mañana';
    } else {
      nodo.textContent = `Quedan ${dias} días`;
    }
  }
}

document.addEventListener('DOMContentLoaded', actualizarCuentasAtras);
